<template>
    <div class="apprentice-simple-card">
        <div
            class="result-graphs"
            v-if="testIssuing.submitted_responses_count">
            <h2>{{$t('testcenter.progress')}}</h2>
            <design-2021-apprentice-radar-chart-component
                :options="chartOptions"
                :series="totalScores">
            </design-2021-apprentice-radar-chart-component>
        </div>
        <design-2021-apprentice-data-table
            class="test-responses"
            dusk="test-responses-table"
            :items="computedResponses"
            :fields="fields">
            <template v-slot:options>
                <b-button
                    class="btn-share"
                    variant="primary"
                    @click="openAddTeacherModal">
                    {{$t('testcenter.manage_administrators')}}
                </b-button>
            </template>

            <template v-slot:cell(answers_count)="data">
                <b-progress
                    class="w-75"
                    v-if="data.item.result_data"
                    v-b-tooltip.hover
                    show-progress
                    :max="testIssuing.test.questions_count"
                    :title="$t('testcenter.finished_questions')">
                    <b-progress-bar
                        :value="testIssuing.test.questions_count"
                        :label="testIssuing.test.questions_count + '/' + testIssuing.test.questions_count"
                        variant="success">
                    </b-progress-bar>
                </b-progress>

                <b-progress
                    class="w-75"
                    v-else
                    v-b-tooltip.hover
                    show-progress
                    :max="testIssuing.test.questions_count"
                    :title="$t('testcenter.finished_questions')">
                    <b-progress-bar
                        :label="data.item.answers_count + '/' + testIssuing.test.questions_count"
                        :value="data.item.answers_count"
                        variant="warning">
                    </b-progress-bar>
                </b-progress>
            </template>

            <template v-slot:cell(actions)="data">
                <div class="management-actions actions">
                    <b-button
                        class="btn-open"
                        v-if="data.item.result_data"
                        :v-b-tooltip="$t('common.open')"
                        variant="primary-icon-only"
                        @click="openResultsModal(data.item)">
                    </b-button>
                </div>
            </template>
        </design-2021-apprentice-data-table>
        <design-2021-test-center-results-modal-component
            :test-issuing-in="testIssuing"
            :show-graph="true"
            :ref="'result-modal'">
        </design-2021-test-center-results-modal-component>
        <design-2021-test-issuing-share-modal-component
            @updateTeachers="updateTeachers($event)"
            :test-issuing-in="testIssuing"
            :ref="'share-modal'">
        </design-2021-test-issuing-share-modal-component>
    </div>
</template>

<script>
import Design2021ApprenticeDataTable from '../common/design-2021-apprentice-data-table.vue';
import { getAttributesForKeys, sortResults } from '../../helpers/testCenter';

export default {
    name: 'design-2021-test-center-show-test-issuing-component',
    components: { Design2021ApprenticeDataTable },
    props: {
        testIssuing: {
            type: Object,
            required: true,
        },
    },
    data() {
        return {
            chartOptions: {
                chart: {
                    height: 350,
                    width: '100%',
                    type: 'radar',
                    toolbar: {
                        tools: {
                            download: false,
                        },
                    },
                },
                plotOptions: {
                    radar: {
                        size: 140,
                        polygons: {
                            strokeColors: '#e9e9e9',
                            fill: {
                                colors: ['#f8f8f8', '#fff'],
                            },
                        },
                    },
                },
                xaxis: {
                    categories: getAttributesForKeys(this.testIssuing.test.key, 'label'),
                },
                yaxis: {
                    show: false,
                },
                tooltip: {
                    enabled: false,
                },
            },
            fields: [
                {
                    key: 'name',
                    label: this.$t('common.name'),
                    sortable: true,
                },
                {
                    key: 'answers_count',
                    label: this.$t('testcenter.progress'),
                    sortable: true,
                },
                {
                    key: 'actions',
                    label: this.$t('common.actions'),
                },
            ],
        };
    },
    computed: {
        // TODO: Move this calculation to the backend
        totalScores() {
            let results = this.testIssuing.responses.filter((response) => response.result_data !== null);
            if (!results.length) return [];

            let keys = Object.keys(results[0].result_data).filter((key) => key !== 'blank');

            const totalResults = results.reduce((acc, response) => {
                keys.forEach((key) => (acc[key] = (acc[key] || 0) + response.result_data[key]));
                return acc;
            }, {});

            return [
                {
                    color: '#07A1FF',
                    data: sortResults(this.testIssuing.test.key, totalResults),
                    name: this.$t('common.total'),
                },
            ];
        },
        computedResponses() {
            return this.testIssuing.responses.map((response) => {
                response.name = response.user.full_name;
                return response;
            });
        }
    },
    methods: {
        openResultsModal(testResponse) {
            this.$refs['result-modal'].show(testResponse);
        },
        openAddTeacherModal() {
            this.$refs['share-modal'].show();
        },
        updateTeachers(teachers) {
            this.testIssuing.teachers = teachers;
            this.alert.success();
        },
    },
};
</script>

<style scoped lang="scss">
.progress-bar[aria-valuenow='0'] {
    color: $text-color;
    min-width: fit-content;
    background: $border-color !important;
    margin-left: calc(50% - 15px);
}
</style>
